import type { TFunction } from 'next-i18next'
import type { ShipmentBookedFilters } from '@frontend-types/shipment'
import type { TablePaginationConfig } from 'antd'
import type { Rule } from 'antd/es/form'

import type { InboundOutboundType, ShipmentStatus } from '@shared/const'

export const HIVEBOUND_MAIN_URL = 'https://www.hivebound.io'
export const PRIVACY_POLICY_URL = `${HIVEBOUND_MAIN_URL}/privacy`

export const DEFAULT_PAGINATION = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: [10, 20, 50, 100],
}

export const DEFAULT_MODAL_PAGINATION: TablePaginationConfig = {
  current: 1,
  pageSize: 6,
  pageSizeOptions: [6, 10, 20, 50, 100],
  showSizeChanger: true,
}

export const SIDE_COLUMN_ID = 'hb_sticky_sider_column_body'

export enum ColumnFilter {
  SHIPMENT_LIST_TABLE = 'shipment_list_table',
  CHECKLIST_LIST_TABLE = 'checklist_list_table',
  SLOT_LIST_TABLE = 'slot_list_table',
  PROCESSING_LIST_TABLE = 'processing_list_table',
  YARD_LIST_TABLE = 'yard_list_table',
  PALLET_LIST_TABLE = 'pallet_list_table',
  GOODS_IN_LIST_TABLE = 'goods_in_list_table',
}

export type ColumnOrderSettingKey = `${ColumnFilter}_column_order`

export const getColumnOrderSettingKey = (tableKey: ColumnFilter): ColumnOrderSettingKey =>
  `${tableKey}_column_order`

export enum TableStateFilter {
  SHIPMENT_LIST_TABLE = 'shipment_table_filters',
  SLOT_LIST_TABLE = 'slot_table_filters',
  YARD_LIST_TABLE = 'yard_table_filters',
  PALLET_LIST_TABLE = 'pallet_table_filters',
  PROCESSING_LIST_TABLE = 'processing_table_filters',
}

type ShipmentTableFilter = {
  shipmentStatusFilters: ShipmentStatus[]
  shipmentTagFilters: string[]
  shipmentBookedFilter: ShipmentBookedFilters | undefined
  shipmentDepartmentIdsFilter: string[]
  shipmentTypeFilters: InboundOutboundType[]
  shipmentType: InboundOutboundType | undefined
}

type DefaultTableFilter = Record<string, unknown>

export type TableStateFilterMapping = {
  [TableStateFilter.SHIPMENT_LIST_TABLE]: ShipmentTableFilter
  [TableStateFilter.SLOT_LIST_TABLE]: DefaultTableFilter
  [TableStateFilter.YARD_LIST_TABLE]: DefaultTableFilter
  [TableStateFilter.PALLET_LIST_TABLE]: DefaultTableFilter
  [TableStateFilter.PROCESSING_LIST_TABLE]: DefaultTableFilter
}

export const requiredRule = (t: TFunction): Rule => ({
  required: true,
  message: t('Required', { ns: 'common' }),
})
